import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=d32ce4b0&scoped=true&"
import script from "./FolderModal.vue?vue&type=script&lang=js&"
export * from "./FolderModal.vue?vue&type=script&lang=js&"
import style0 from "./FolderModal.vue?vue&type=style&index=0&id=d32ce4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32ce4b0",
  null
  
)

export default component.exports